import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { withTranslation } from 'react-i18next';

class ErrorDiv extends Component {
  render() {
    const { t, error, type, message, mt } = this.props;

    return (
      <div style={mt ? { marginTop: '1rem' } : {}}>
        <Alert isOpen={error} width="100%" color="danger" className={type === 'bottom' ? 'fixed-bottom' : ''}>
          <div className={type === 'bottom' ? 'container' : ''}>
            <i className="fas fa-exclamation-circle"></i> {message ? t(message) : t('cart|Erreur réseau, veuillez réessayer plus tard')}
          </div>
        </Alert>
      </div>
    );
  }
}

export default withTranslation()(ErrorDiv);
